export default "__VITE_ASSET__057269c0__"